<script setup lang="ts">

import { faArrowUpFromBracket } from '@fortawesome/pro-regular-svg-icons'

import { FilterTutors } from '@entities/tutor'
import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'
import { AppMultiSelect } from '@shared/ui/selects'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'

import { useFiltersDisciplineTasks } from '../model/filters-discipline-tasks.hook'

defineOptions({
  name: 'FiltersDisciplineTasks',
})

const {
  refSearch,
  refTutorIds,
  refDueDateRange,
  refStatuses,
  refTypes,
  statusOptions,
  typeOptions,
  searchMaxLength,
  isLoading,
  isExporting,
  canManageTutorTasks,
  search,
  clearFilters,
  exportTasks,
  openCreateTask,
} = useFiltersDisciplineTasks()
</script>

<template>
  <FiltersBar
    class="filters-discipline-tasks"
    :loading="isLoading"
    @click:submit="search"
    @click:clear="clearFilters"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        class="filters-discipline-tasks__search"
        label="Search"
        placeholder="Search"
        :max-length="searchMaxLength"
        :disabled="isLoading"
      />

      <FilterTutors
        v-model="refTutorIds"
        class="filters-discipline-tasks__tutors"
        active
        paid
        with-paid-label
        :disabled="isLoading"
      />

      <FilterDateRange
        v-model="refDueDateRange"
        presets
        class="filters-discipline-tasks__date"
        label="Due date & time"
        placeholder="Search"
        :disabled="isLoading"
      />

      <AppMultiSelect
        v-model="refStatuses"
        class="filters-discipline-tasks__status"
        :options="statusOptions"
        label="Status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <AppMultiSelect
        v-model="refTypes"
        class="filters-discipline-tasks__type"
        :options="typeOptions"
        label="Task type"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </template>

    <template #end>
      <BtnIcon
        :icon="faArrowUpFromBracket"
        title="Export as CSV"
        tooltip-text="Export as CSV"
        :disabled="isExporting"
        @click="exportTasks"
      />

      <BtnPrimary
        v-if="canManageTutorTasks"
        text="Create task"
        color="emerald"
        @click="openCreateTask"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersDisciplineTasks.scss" />
